import { Icon, IconName, DropdownItem } from '@optimus-web/core';

interface Props {
    icon?: IconName;
    text?: React.ReactNode;
    onClick?: () => void;
}

export const CustomMenuItem = ({ onClick, text, icon, ...rest }: Props) => {
    const componentProps = {
        leftDetail: icon ? <Icon value={icon} /> : undefined,
        label: text,
        onClick,
        role: 'menuitem',
    };

    return <DropdownItem {...rest} {...componentProps} />;
};
